import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-g2-prompt-dialog',
  templateUrl: './g2-prompt-dialog.component.html',
  styleUrls: ['./g2-prompt-dialog.component.scss'],
})
export class G2PromptDialogComponent {
  constructor(public dialogRef: MatDialogRef<G2PromptDialogComponent>) {}

  yes(): void {
    this.dialogRef.close(true);
  }

  no(): void {
    this.dialogRef.close(false);
  }
}
